export default "__VITE_ASSET__6bbf5099__$_?component__"